import {memo} from 'react';
import {useNavigate} from 'react-router-dom';
import {PetFeeInfoModal as SharedPetFeeInfoModal} from '@chekin/shared/payments';
import {PATHS} from 'routes/constants';
import {usePath} from '../../../hooks';
import {useChatSettings} from 'hooks/useChatSettings';

type Props = {
  isOpen: boolean;
  close: () => void;
};

const PetFeeInfoModal = memo(({isOpen, close}: Props) => {
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {isChatEnabled} = useChatSettings();

  return (
    <SharedPetFeeInfoModal
      isOpen={isOpen}
      close={close}
      onMessageProperty={
        isChatEnabled ? () => navigate(getFullPath(PATHS.chat)) : undefined
      }
    />
  );
});

export {PetFeeInfoModal};
